module.exports = __webpack_public_path__ + "media/images/btn-play-1f1bb412233751c1114887ea18335e2f.png";